(function ($, window) {
	'use strict';

	$(function () {
		const interval = 250;
		const visibleHeight = 400;
		const activeClass = 'sticky-header-active';
		const $body = $('body');
		const $stickyHeader = $('.js-sticky-header');

		let didScroll = false;
		let lastScroll = 0;

		$(window).on('scroll', function () {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				handleScroll();
				didScroll = false;
			}
		}, interval);

		const handleScroll = () => {
			const currentScrollTop = ($(window).scrollTop() || $('body').scrollTop());

			if (currentScrollTop > visibleHeight && currentScrollTop < lastScroll) {
				if (!$body.hasClass(activeClass)) {
					$body.addClass(activeClass);
				}
			} else {
				if ($body.hasClass(activeClass)) {
					$body.removeClass(activeClass);
				}
			}

			lastScroll = currentScrollTop;
		};

		$(window).trigger('scroll');

		$('*', $stickyHeader).each(function (index, child) {
			$(child).attr('tabindex', '-1');
		});
	});
})(jQuery, window);
